import React from "react";
import moment from "moment";
import { compose } from "redux";
import classNames from "classnames";
import { Chip, Grid } from "@material-ui/core";
import * as colors from "@material-ui/core/colors";
import { withStyles } from "@material-ui/core/styles";

import Link from "app/components/Link";
import { Format } from "app/app.constants";
import config from "infrastructure/config";
import { formatDate } from "utils/format.util";

import { EMPTY_LIST } from "app/app.constants";

const ProjectsContainer = ({ classes, projects = EMPTY_LIST }) => {
  return (
    <>
      <Grid container className={classes.root}>
        {projects.map(project => (
          <Grid
            item
            container
            key={project.get("projectId")}
            className={classes.row}
          >
            <Grid xs={true} item container className={classes.m3num}>
              <Link
                classes={{
                  root: classes.projectName,
                  icon: classes.linkIcon,
                }}
                external
                target="_blank"
                href={`${config.diClientUrl}/projects/${project.get(
                  "dwiProjectId",
                )}`}
              >
                {project.get("displayName")}
              </Link>
            </Grid>

            <Grid
              item
              container
              xs
              justifyContent="flex-end"
              className={classes.dateCell}
            >
              <Grid item className={classes.m3num}>
                {project.get("m3ProjectNumber")}
              </Grid>
              <Grid item xs={2}>
                <Chip
                  label={project.get("assignedPeople")}
                  title={"Crew members"}
                  classes={{
                    root: classNames(classes.chipRoot),
                  }}
                />
              </Grid>
              <Grid item>
                {project.get("startTime")
                  ? formatDate(moment(project.get("startTime")), Format.date)
                  : ""}{" "}
                -{" "}
                {project.get("endTime")
                  ? formatDate(moment(project.get("endTime")), Format.date)
                  : ""}
              </Grid>
            </Grid>
          </Grid>
        ))}
      </Grid>
    </>
  );
};

const styles = theme => ({
  root: {
    top: 0,
    zIndex: 2,
    width: "100%",
    display: "flex",
    position: "sticky",
    alignItems: "center",
    background: theme.palette.grey[200],
    color: theme.palette.common.white,
    ...theme.typography.caption,
    lineHeight: "100%",
    fontWeight: theme.typography.fontWeightMedium,
  },
  row: {
    alignItems: "center",
    justifyContent: "center",
    background: theme.altus.background.projectRow,
    height: "32px",
    padding: `0 ${theme.spacing(1)}px`,
  },
  dateCell: {
    alignItems: "center",
  },
  chipRoot: {
    height: "1.5rem",
    background: theme.altus.background.headerChip,
    color: theme.palette.primary.contrastText,
    fontWeight: theme.typography.fontWei,
  },
  projectName: {
    fontSize: "0.75rem",
    color: colors.blue[100],
    "&:hover": {
      cursor: "pointer",
      textDecoration: "underline",
    },
  },
  linkIcon: {
    display: "none",
  },
  m3num: {
    marginRight: "5px",
  },
});
export default compose(withStyles(styles))(ProjectsContainer);
